<template>
  <div class="dashboard-page">
    <h1>Dashboard</h1>
    <p>Welcome back, here is your personal dashboard.</p>
  </div>
</template>

<script>
export default {
  name: "DashboardPage",
};
</script>

<style scoped>
.dashboard-page {
  text-align: center;
  margin-top: 50px;
}
</style>
